import type { RootState } from '..';

export const selectUX = (state: RootState) => {
  return state.ux;
};
